import React from 'react'

const Footer = () => {
  return (
    <div className='text-xl text-center w-full py-5 underline decoration-dashed'>Made by Kevin & Zeus</div>
  )
}

export default Footer